export default __webpack_public_path__ + "static/media/dracoo_logo.dbdf2cb4.png";